<div class="card">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ "MENU.RESIGNED_EMPLOYEE" | translate }}</h4>
    <a *ngIf="resignedEmployees.length > 0" routerLink="/dashboard/user/resigned-employees">{{ "VIEW_ALL" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="resignedEmployees.length < 1">{{ "NO_RESIGNED_EMPLOYEES" | translate }}</div>
    <div *ngFor="let resignedEmployee of resignedEmployees" class="row mb-1">
      <div class="col-12">
        <a class="font-weight-medium text-break-line-1 mb-0" [routerLink]="'/dashboard/user/profile/' + resignedEmployee.user_hash">
          {{ resignedEmployee.complete_name }}
        </a>
        <small>
          {{ "FROM" | translate }} {{ resignedEmployee.closed_at ? _utilsService.formatDate(resignedEmployee.closed_at) : _utilsService.formatDate(resignedEmployee.end_date) }} -
          {{ resignedEmployee.figure_name }}
        </small>
      </div>
    </div>
  </div>
</div>
